var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulletinGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 216.22,
    y1: 171.54,
    x2: 143.66,
    y2: 193.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8dee8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2a7ae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 244.01,
    y1: 92.9,
    x2: 158.2,
    y2: 226.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ebeff2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 291.56,
    y1: 64.94,
    x2: 42.43,
    y2: 345.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 123.05,
    y1: 167.81,
    x2: 146.27,
    y2: 223.21,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 123.5,
    y1: 162.5,
    x2: 146.72,
    y2: 217.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa80f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 121.78,
    y1: 173.41,
    x2: 127.11,
    y2: 173.41,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 128.37,
    y1: 173.62,
    x2: 133.59,
    y2: 173.62,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 134.81,
    y1: 173.83,
    x2: 139.91,
    y2: 173.83,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 141.11,
    y1: 174.03,
    x2: 146.09,
    y2: 174.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 147.26,
    y1: 174.23,
    x2: 152.14,
    y2: 174.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 108.12,
    y1: 178.62,
    x2: 113.71,
    y2: 178.62,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 115.03,
    y1: 178.77,
    x2: 120.49,
    y2: 178.77,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 121.78,
    y1: 178.92,
    x2: 127.11,
    y2: 178.92,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 128.37,
    y1: 179.07,
    x2: 133.59,
    y2: 179.07,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 134.81,
    y1: 179.22,
    x2: 139.91,
    y2: 179.22,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 141.11,
    y1: 179.36,
    x2: 146.09,
    y2: 179.36,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 147.26,
    y1: 179.5,
    x2: 152.14,
    y2: 179.5,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 108.12,
    y1: 184.26,
    x2: 113.71,
    y2: 184.26,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 115.03,
    y1: 184.35,
    x2: 120.49,
    y2: 184.35,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 121.78,
    y1: 184.44,
    x2: 127.11,
    y2: 184.44,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 128.37,
    y1: 184.52,
    x2: 133.59,
    y2: 184.52,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 134.81,
    y1: 184.61,
    x2: 139.91,
    y2: 184.61,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 141.11,
    y1: 184.69,
    x2: 146.09,
    y2: 184.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 147.26,
    y1: 184.77,
    x2: 152.14,
    y2: 184.77,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 108.12,
    y1: 189.91,
    x2: 113.71,
    y2: 189.91,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 115.03,
    y1: 189.93,
    x2: 120.49,
    y2: 189.93,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 121.78,
    y1: 189.95,
    x2: 127.11,
    y2: 189.95,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 128.37,
    y1: 189.98,
    x2: 133.59,
    y2: 189.98,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 134.81,
    y1: 190,
    x2: 139.91,
    y2: 190,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 137.32,
    y1: 126.88,
    x2: 167.92,
    y2: 113.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e38ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 197.72,
    y1: 178.96,
    x2: 221.83,
    y2: 350.32,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 215.37,
    y1: 113.72,
    x2: 210.45,
    y2: 287.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 176.93,
    y1: 492.56,
    x2: 180.18,
    y2: 515.6,
    gradientTransform: "matrix(0.99, -0.16, 0.16, 0.99, 3.84, -276.47)",
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -599.98,
    y1: 1084.51,
    x2: -597.02,
    y2: 1105.51,
    gradientTransform: "matrix(1.21, -0.61, 0.45, 0.89, 437.93, -1135.95)",
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 238.41,
    y1: -170.47,
    x2: 242.35,
    y2: -158.75,
    gradientTransform: "matrix(0.97, 0.23, -0.23, 0.97, -28.58, 394.03)",
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 233.37,
    y1: -168.73,
    x2: 237.28,
    y2: -157.1,
    gradientTransform: "matrix(0.97, 0.23, -0.23, 0.97, -28.58, 394.03)",
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 263.64,
    y1: 264.76,
    x2: 228.44,
    y2: 265.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 249.27,
    y1: -176.48,
    x2: 230.79,
    y2: -197.32,
    gradientTransform: "matrix(0.97, 0.23, -0.23, 0.97, -28.58, 394.03)",
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 274.6,
    y1: 284.91,
    x2: 238.89,
    y2: 264.04,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 225.32,
    y1: 178.14,
    x2: 242.31,
    y2: 240.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 233.62,
    y1: 202.07,
    x2: 236.69,
    y2: 211.12,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -242.28,
    y1: 314.66,
    x2: -239.21,
    y2: 323.71,
    gradientTransform: "translate(514.58)",
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 238.85,
    y1: 213.84,
    x2: 236.02,
    y2: 202.62,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 238.61,
    y1: 205.34,
    x2: 234.65,
    y2: 202.14,
    xlinkHref: "#linear-gradient-37"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -176.06,
    y1: 369.49,
    x2: -168.15,
    y2: 382.24,
    gradientTransform: "translate(514.58)",
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 213.87,
    y1: 181.26,
    x2: 230.86,
    y2: 243.66,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 217.68,
    y1: 166.76,
    x2: 235.44,
    y2: 292.95,
    xlinkHref: "#linear-gradient-2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.14,
    y: 50.91,
    width: 278.51,
    height: 229.77,
    style: {
      fill: "#ebf2f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.41,294.81c-4.27.39-7.76-3.8-7.76-9.33V92.09c0-5.54,3.49-9.85,7.76-9.62L278.54,96.41c3.24.18,6.71.32,6.71,5.11V268.76c0,4.78-2.62,8.92-5.86,9.21Z",
    style: {
      mixBlendMode: "multiply",
      opacity: 0.54,
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.91,294.81c-4.27.39-7.77-3.8-7.77-9.33V92.09c0-5.54,3.5-9.85,7.77-9.62l184,10c3.24.18,5.87,4.21,5.87,9V268.76c0,4.78-2.63,8.92-5.87,9.21Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.88,98.29l-184-9.21c-1.45-.07-2.62,1.38-2.62,3.25V285c0,1.87,1.17,3.29,2.62,3.16l184-16c1.1-.09,2-1.49,2-3.12V101.34C282.87,99.71,282,98.34,280.88,98.29Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.53
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.78,268.64a1.29,1.29,0,0,1-1.29-1.29V107.53a1.29,1.29,0,0,1,2.57,0V267.35A1.28,1.28,0,0,1,161.78,268.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.88,263.69a1.29,1.29,0,0,1-1.29-1.29V110.08a1.29,1.29,0,1,1,2.57,0V262.4A1.28,1.28,0,0,1,226.88,263.69Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.9,165v26.28a44.26,44.26,0,0,0,1.55,11.62l.4,1.45a1.22,1.22,0,0,0,1.19.91h50.08a1.06,1.06,0,0,0,1-1.29c-.6-2.68-1.89-8.88-1.89-12.47l-2.88-22.75c0-1.11,2-3.48.89-3.51l-49.1-1.47A1.23,1.23,0,0,0,103.9,165Z",
    style: {
      mixBlendMode: "multiply",
      opacity: 0.30000000000000004,
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.9,159.89v26.28a44.32,44.32,0,0,0,1.55,11.62l.4,1.45a1.22,1.22,0,0,0,1.19.91h50.08a1.06,1.06,0,0,0,1-1.29c-.6-2.68-1.89-8.88-1.89-12.48v-24.2a2.05,2.05,0,0,0-2-2.05l-49.1-1.48A1.23,1.23,0,0,0,103.9,159.89Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.64,168.5h0l-43-1.08a.75.75,0,1,1,0-1.49l43,1.08a.73.73,0,0,1,.72.76A.74.74,0,0,1,151.64,168.5Z",
    style: {
      fill: "#fff",
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.19
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "127.11 175.34 121.78 175.18 121.78 171.48 127.11 171.67 127.11 175.34",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.59 175.53 128.37 175.38 128.37 171.72 133.59 171.9 133.59 175.53",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.91 175.71 134.81 175.56 134.81 171.94 139.91 172.13 139.91 175.71",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.09 175.89 141.11 175.75 141.11 172.17 146.09 172.35 146.09 175.89",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.14 176.07 147.26 175.93 147.26 172.39 152.14 172.56 152.14 176.07",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.71 180.57 108.12 180.46 108.12 176.67 113.71 176.81 113.71 180.57",
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.49 180.7 115.03 180.59 115.03 176.85 120.49 176.99 120.49 180.7",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.11 180.83 121.78 180.72 121.78 177.02 127.11 177.16 127.11 180.83",
    style: {
      fill: "url(#linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.59 180.95 128.37 180.85 128.37 177.19 133.59 177.33 133.59 180.95",
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.91 181.08 134.81 180.98 134.81 177.36 139.91 177.49 139.91 181.08",
    style: {
      fill: "url(#linear-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.09 181.2 141.11 181.1 141.11 177.52 146.09 177.65 146.09 181.2",
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.14 181.31 147.26 181.22 147.26 177.68 152.14 177.81 152.14 181.31",
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.71 186.19 108.12 186.13 108.12 182.34 113.71 182.43 113.71 186.19",
    style: {
      fill: "url(#linear-gradient-18)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.49 186.25 115.03 186.2 115.03 182.45 120.49 182.54 120.49 186.25",
    style: {
      fill: "url(#linear-gradient-19)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.11 186.32 121.78 186.26 121.78 182.56 127.11 182.65 127.11 186.32",
    style: {
      fill: "url(#linear-gradient-20)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.59 186.38 128.37 186.33 128.37 182.67 133.59 182.75 133.59 186.38",
    style: {
      fill: "url(#linear-gradient-21)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.91 186.44 134.81 186.39 134.81 182.77 139.91 182.86 139.91 186.44",
    style: {
      fill: "url(#linear-gradient-22)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.09 186.5 141.11 186.45 141.11 182.88 146.09 182.96 146.09 186.5",
    style: {
      fill: "url(#linear-gradient-23)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.14 186.56 147.26 186.51 147.26 182.97 152.14 183.05 152.14 186.56",
    style: {
      fill: "url(#linear-gradient-24)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.71 191.81 108.12 191.81 108.12 188.01 113.71 188.05 113.71 191.81",
    style: {
      fill: "url(#linear-gradient-25)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.49 191.81 115.03 191.81 115.03 188.06 120.49 188.09 120.49 191.81",
    style: {
      fill: "url(#linear-gradient-26)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.11 191.81 121.78 191.81 121.78 188.1 127.11 188.14 127.11 191.81",
    style: {
      fill: "url(#linear-gradient-27)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.59 191.81 128.37 191.81 128.37 188.15 133.59 188.18 133.59 191.81",
    style: {
      fill: "url(#linear-gradient-28)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.91 191.81 134.81 191.81 134.81 188.19 139.91 188.22 139.91 191.81",
    style: {
      fill: "url(#linear-gradient-29)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.05,112.2c.09,16.4.92,31.12,6.46,35l43.52-.3c-2.92-10.47-6.58-21.47-5.82-33.34Z",
    style: {
      fill: "url(#linear-gradient-30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.13,119v75a2.92,2.92,0,0,0,3.27,2.9l63.87-7.59a3.53,3.53,0,0,0,3-4.4c-1.78-6.87-5.18-21.33-5.2-31.4a.73.73,0,0,0-.37-.64l-63.5-34.51A.73.73,0,0,0,164.13,119Z",
    style: {
      mixBlendMode: "multiply",
      opacity: 0.30000000000000004,
      fill: "url(#linear-gradient-31)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.39,117.7l77.15-7.91a1.16,1.16,0,0,1,1.25,1c1,6.39,6.9,40,20.59,61.48a1.15,1.15,0,0,1-.73,1.74l-69,14.79a1.12,1.12,0,0,1-1-.24c-2.88-2.44-18.94-18-29.26-69.45A1.14,1.14,0,0,1,165.39,117.7Z",
    style: {
      fill: "url(#linear-gradient-32)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.71,182.54l-.84-5a3.32,3.32,0,0,0-.71-4.26c-2.19-1.81,3.21-1,3.64,3.11l-1.36,2.43,2.31,3.25Z",
    style: {
      fill: "url(#linear-gradient-33)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.47,195.67l-2.08-5.1a2.84,2.84,0,0,0-.67-2.67c-1.11-1-.59-.68-.6.31s-1.48.06-2.71-.83-.61,1.13.09,2.15a3.85,3.85,0,0,0,2.39,2c1.3.35,1.36,4.14,1.36,4.14Z",
    style: {
      fill: "url(#linear-gradient-34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.36,290.36c.2-.73,2-.16,3.11.22s1.56,1,1.64,1.47-.32,1.54-1.29.83C242,292.29,239.18,291,239.36,290.36Z",
    style: {
      fill: "#26264f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.2,288l.16,3.07s.7.78,1,.55l.47-3.39Z",
    style: {
      fill: "url(#linear-gradient-35)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.69 284.9 239.18 286.75 238.38 288.05 235.78 286.68 236.69 284.9",
    style: {
      fill: "url(#linear-gradient-36)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.26,290.3s1.73.9,2.81,0a10.71,10.71,0,0,0,1.82-2.37.84.84,0,0,0-.24-1.13c-.53-.37-1.26-.81-1.65-.7-.64.19-.61,2.43-1,2.93S235.35,289.61,235.26,290.3Z",
    style: {
      fill: "#26264f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.34,240.71a157.9,157.9,0,0,0-.7,48.29,3.07,3.07,0,0,0,2.62.62c1.26-3.34,2.18-6.2,2.82-8.33,1.67-5.62,2.51-8.51,2.53-12.09,0-3.35-.62-3.24-.56-6.94a40.81,40.81,0,0,1,1.43-9.23,84,84,0,0,1,2.82-9.44Z",
    style: {
      fill: "url(#linear-gradient-37)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.55,286.73c-.18-2.53,1.52-3.27,2-6.3.65-3.71-1.57-4.35-1.32-8.63.2-3.44,1.66-3.4,2.23-7.5.61-4.36-.86-5.62.09-8.11.53-1.38,1.81-3.13,5.23-4.56a83.66,83.66,0,0,1,2.47-8l-11-2.88a157.9,157.9,0,0,0-.7,48.29,3.16,3.16,0,0,0,1.15.59,3.06,3.06,0,0,0,.8.1A6.28,6.28,0,0,1,242.55,286.73Z",
    style: {
      mixBlendMode: "multiply",
      opacity: 0.30000000000000004,
      fill: "url(#linear-gradient-38)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.65,237.43a67.23,67.23,0,0,1-2.59,6.76c-2.82,6.31-4.78,8.08-6.18,12.31a25.44,25.44,0,0,0-1,10.85c1.16,11.13,9.84,18.22,12.16,20l1.55-2.64A26.29,26.29,0,0,1,236,280c-.81-3.54-.48-5.44-.81-8.82-.59-6.09-2.23-5.63-1.91-8.59.51-4.69,4.62-5.67,10-13.6a49.08,49.08,0,0,0,3.19-5.46Z",
    style: {
      fill: "url(#linear-gradient-39)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,179.32l4.53-.25a32.86,32.86,0,0,1,4.13,16.05,31.84,31.84,0,0,1-3.12,13.62,30.83,30.83,0,0,1-8.33,10.42c0,8.35.15,13.62.44,16.77a41.54,41.54,0,0,1-.1,7.68,8.4,8.4,0,0,1-.37,2.24c-2.38,4.8-16,1-19.71-.6a4.07,4.07,0,0,1-2.35-2c-.53-1.31,0-2.5.19-3.54.51-2.55-1-4.47-4-9.42-1.29-2.09-3.16-5.23-5.34-9.31-2.52.74-8.47,2.06-14.29-.72-8.55-4.08-13.43-15.38-10.94-27.63l2.6-.74a26,26,0,0,0,3.95,8.8c1.38,2,2.53,3.59,4.52,4.5,3.12,1.43,5.9,0,9.95-1,2.22-.55,1.54-.11,18.23-.27,7.13-.08,8.57-.16,10.75-.93a17.51,17.51,0,0,0,8.8-6.29C260.54,189.32,256.35,180,256,179.32Z",
    style: {
      fill: "url(#linear-gradient-40)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.44,198.32s-.43,1.71.17,2.47,2.6,3.69,3.25,3.83c.37.08,1.3.22,2,.33a.39.39,0,0,1,.11.74,10.48,10.48,0,0,1-4.22.61,15,15,0,0,1-6.86-1.87.17.17,0,0,1,.1-.32l1.43.11a2,2,0,0,0,2.1-2.18l-.09-.8Z",
    style: {
      fill: "url(#linear-gradient-41)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.12,201.75c-.19-.11-1.79-.3-2-1.16-.3-1.17.75-2.59.88-2.82.55-1,.68-1.09.94-1.25l.35-.21h0a4.14,4.14,0,0,1,1.15-.05c.49.12,1,2.14.75,5,0,.11,0,.22.05.33C235.32,201.85,233.11,201.85,233.12,201.75Z",
    style: {
      fill: "url(#linear-gradient-42)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.62,196.13c-.07.35.85,1,1.24,1.34a1.27,1.27,0,0,1,.31.35.37.37,0,0,1,.05.11c.18.56-.72,1.19-.55,1.44s.72,0,.79.12-.44.44-.37.61.37,0,.55.23.07.18.16.5a3.79,3.79,0,0,0,.19.47c.3.53,1.15.73,1.33.53s0-.1.06-.3a1.29,1.29,0,0,1,.17-.38,4.33,4.33,0,0,1,1.06-.8,2.89,2.89,0,0,0,1.12-1.21l0,0,0-.09c.18-.56-.54-1.54-.54-1.54a6.06,6.06,0,0,0-1.88-1.62,8.44,8.44,0,0,0-2.52-.12C232.35,195.78,231.67,195.86,231.62,196.13Z",
    style: {
      fill: "url(#linear-gradient-43)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.29,199.06s.68.81,1.57-.17l.44.13A12.24,12.24,0,0,1,232,201.4a7.09,7.09,0,0,1-.9-.15.57.57,0,0,1-.34-.65A8.35,8.35,0,0,1,231.29,199.06Z",
    style: {
      fill: "url(#linear-gradient-44)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.08,199.17c.22-.29.59,0,.59.38s-.39.78-.75.69S232.78,199.57,233.08,199.17Z",
    style: {
      fill: "url(#linear-gradient-45)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.59,244.45c-4.62,1.63-10-.75-11.35-4-1-2.4,1.13-4.69-.38-7.17S233.8,232,232,229.56c-2-2.62.35-4.95-1.39-8.47-1.32-2.64-4.46-5-7.54-5-3.67,0-5,3.38-8.19,2.7-1.65-.36-1.61-1.35-3.91-3-4-2.82-6.67-1.64-9.95-3.63a9.89,9.89,0,0,1-3.05-2.92,20,20,0,0,0,9.71,11c5.82,2.78,11.77,1.46,14.29.72,2.18,4.08,4.05,7.22,5.34,9.31,3,4.95,4.55,6.87,4,9.42-.21,1-.72,2.23-.19,3.54a4.07,4.07,0,0,0,2.35,2c3.69,1.59,17.33,5.4,19.71.6a8.4,8.4,0,0,0,.37-2.24c.08-.78.14-1.53.17-2.23A9.07,9.07,0,0,1,249.59,244.45Z",
    style: {
      mixBlendMode: "multiply",
      opacity: 0.30000000000000004,
      fill: "url(#linear-gradient-46)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.77,152.31c-8.71-2.19-11-11.26-18.92-11.2s-9.59,9-16.63,8.56c-8-.47-9.55-12.23-19.91-15a18.47,18.47,0,0,0-10,.36,137.78,137.78,0,0,0,19.21,46.24l63.35-13a92,92,0,0,1-7.89-16.4A16.93,16.93,0,0,1,239.77,152.31Z",
    style: {
      opacity: 0.19,
      fill: "url(#linear-gradient-47)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.46,125.45a1.29,1.29,0,0,1-.12-2.57l65.5-6.33a1.29,1.29,0,0,1,.25,2.56l-65.5,6.33Z",
    style: {
      fill: "#fff",
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.16,129.4a1.29,1.29,0,0,1-1.28-1.15,1.27,1.27,0,0,1,1.14-1.41l42-4.61a1.28,1.28,0,0,1,.28,2.55l-42,4.61Z",
    style: {
      fill: "#fff",
      mixBlendMode: "soft-light"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletinGraphic);
export default __webpack_public_path__ + "static/media/bulletin_graphic.1b2200d346ba6aa526fc3edb25691c54.svg";
export { ForwardRef as ReactComponent };